import { render, staticRenderFns } from "./PolipectomiaEndoscopicaIntestinoCrassoView.vue?vue&type=template&id=35cc93c2"
import script from "./PolipectomiaEndoscopicaIntestinoCrassoView.vue?vue&type=script&lang=js"
export * from "./PolipectomiaEndoscopicaIntestinoCrassoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports